const updates = [
  {
    date: '07.31',
    title: '鬼灭之刃 柱训练篇 第6话更新',
    desc: '本周最新话已上线，炭治郎与富冈义勇的修行进入关键阶段，高清1080P画质。',
    tag: '新番更新',
  },
  {
    date: '07.30',
    title: '迷宫饭 第二季 第3话上线',
    desc: '莱欧斯小队的迷宫美食之旅继续，本话新增3道魔物料理，画质和翻译均已优化。',
    tag: '新番更新',
  },
  {
    date: '07.29',
    title: '国漫专区新增《雾山五行·犀川幻紫林》',
    desc: '国产动画神作雾山五行新篇章正式上线，水墨风战斗场面惊艳，国漫迷必看。',
    tag: '国漫上新',
  },
  {
    date: '07.28',
    title: '播放器全面升级，加载速度提升40%',
    desc: '6080影视播放引擎已升级至最新版本，CDN节点扩充至全国30+城市，追番更流畅。',
    tag: '平台公告',
  },
  {
    date: '07.27',
    title: 'Re:从零开始的异世界生活 第三季 第8话',
    desc: '菜月昴在水门都市遭遇新的危机，剧情进入白热化阶段，本话信息量极大。',
    tag: '新番更新',
  },
  {
    date: '07.26',
    title: '经典番剧专区新增《钢之炼金术师FA》',
    desc: '全51话高清修复版已上线，神作重温专区再添一部经典，评分9.9的神级动漫。',
    tag: '经典上线',
  },
  {
    date: '07.25',
    title: '时光代理人 第三季 全12话完结',
    desc: '本季最终话催泪收官，程小时与陆光的时空之旅暂告段落，全季高清合集已整理。',
    tag: '完结撒花',
  },
];

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">更新动态</h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-8 md:mb-10">最新动漫上线与平台公告</p>
        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-[18px] md:left-[22px] top-2 bottom-2 w-0.5 bg-background-300"></div>

          <div className="space-y-4 md:space-y-5">
            {updates.map((item, i) => (
              <div key={i} className="relative flex gap-4 md:gap-5 pl-12 md:pl-14">
                {/* Timeline dot */}
                <div className={`absolute left-[10px] md:left-[12px] top-1.5 w-4 h-4 md:w-5 md:h-5 rounded-full border-2 border-background-50 ${
                  item.tag === '新番更新' ? 'bg-primary-500' :
                  item.tag === '国漫上新' ? 'bg-accent-500' :
                  item.tag === '平台公告' ? 'bg-secondary-500' :
                  'bg-foreground-400'
                }`}></div>

                {/* Content */}
                <div className="flex-1 rounded-xl bg-background-50 border border-background-200/70 p-3 md:p-4 transition-colors hover:border-primary-200 cursor-pointer">
                  <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                    <span className="text-xs font-heading font-bold text-primary-500 whitespace-nowrap">{item.date}</span>
                    <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${
                      item.tag === '新番更新' ? 'bg-primary-100 text-primary-700' :
                      item.tag === '国漫上新' ? 'bg-accent-100 text-accent-700' :
                      item.tag === '平台公告' ? 'bg-secondary-100 text-secondary-700' :
                      'bg-background-100 text-foreground-600'
                    }`}>{item.tag}</span>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1">{item.title}</h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}